import React from "react";
import { motion } from "framer-motion";
import { Trophy } from "lucide-react";
import ConnectionMotif from "@/components/ConnectionMotif";
import FiberUnderline from "@/components/FiberUnderline";

function WinnerCard({ w, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ delay: index * 0.12, duration: 0.6 }}
      className="group relative overflow-hidden rounded-2xl border border-white/10 bg-[#0f0f13]"
      data-testid={`winner-card-${index}`}
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        {w.image ? (
          <img src={w.image} alt={w.name || w.category} className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105" />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-[#1a1206] to-[#0f0f13]">
            <Trophy size={46} className="text-[#f5c542]/70" />
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0f0f13] via-transparent to-transparent" />
        <span className="absolute left-3 top-3 rounded-full bg-[#f5c542]/15 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-[#f5c542] backdrop-blur">
          {w.category}
        </span>
      </div>
      <div className="p-5">
        <div className="flex items-center gap-2 text-[#f5c542]">
          <Trophy size={15} />
          <span className="text-xs font-semibold uppercase tracking-wider">Campioni {w.year || ""}</span>
        </div>
        <p className="mt-1 font-display text-lg font-bold text-white">
          {w.name ? w.name : w.image ? `Vincitori ${w.category}` : "Foto in arrivo"}
        </p>
      </div>
    </motion.div>
  );
}

export default function WinnersSection({ winners = [] }) {
  if (!winners || winners.length === 0) return null;
  return (
    <section className="relative isolate mx-auto w-full max-w-7xl overflow-hidden px-6 py-24 md:px-10 md:py-32" data-testid="winners-section">
      <ConnectionMotif className="-z-10 opacity-[0.1]" />
      <div className="speed-line mb-16" />
      <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="text-xs font-semibold uppercase tracking-[0.3em] text-[#f5c542]">
        Albo d'Oro
      </motion.p>
      <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mt-4 font-display text-3xl font-black tracking-tight sm:text-4xl lg:text-5xl">
        I CAMPIONI DELLO SCORSO ANNO
      </motion.h2>
      <FiberUnderline />
      <p className="mt-6 max-w-2xl text-base text-white/60 md:text-lg">
        Chi ha alzato il trofeo l'anno scorso? Ecco i protagonisti da battere. Riuscirai a prendere il loro posto?
      </p>

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {winners.map((w, i) => (
          <WinnerCard key={i} w={w} index={i} />
        ))}
      </div>
    </section>
  );
}
